$(document).on("click", ".question_product,.faq_question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.faq_question').removeClass('active');
    jQuery('.question_product,.faq_question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});
$(document).on("click", ".show_more_toggle", function (e) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
});


$(document).on("click", ".custom_button", function (e) {
    var video = jQuery(this).parents('.video_wrapper_custom').find('video');
if (jQuery(this).hasClass("active")) {
   jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
    jQuery(this).removeClass('active');
video.trigger('pause');
} else {
video.trigger('play');
  jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
    jQuery(this).addClass('active');
}
});

$(document).on("click", ".trigger_reviews_js_show", function (e) {
$('.review_with_text_landing_page_item.active').last().next().show();
$('.review_with_text_landing_page_item.active').last().next().next().show();
$('.review_with_text_landing_page_item.active').last().next().next().next().show();
$('.review_with_text_landing_page_item.active').last().next().addClass('active');
$('.review_with_text_landing_page_item.active').last().next().addClass('active');
$('.review_with_text_landing_page_item.active').last().next().addClass('active');
});








$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.product_label_lp1').scrollIntoView({
    behavior: 'smooth'
  })
});



jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});



function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

$(window).scroll(function () {
    $('.custom_counter .icons_with_text_flex').each(function () {
      var this_element =  $(this);
      if (this_element.hasClass("start_count")) {
} else {
        if (isScrolledIntoView(this) === true) {
            this_element.addClass('start_count');
$('.count_js').each(function () {
    $(this).prop('Counter', 0).animate({
            Counter: $(this).data('value')
        }, {
        duration: 1000,
        easing: 'swing',
        step: function (now) {                      
            $(this).text(Math.ceil(now));
        }
    });
});
        }
      }
    });

});



$(document).on("click", ".cart_item:not(.custom_bundle_item) .remove_item", function (e) {
  e.preventDefault();
var this_element =  jQuery('.quick-cart__container');
this_element.addClass('loading_hk');
var link = $(this).attr('href');
var current_url = location.href;
jQuery.ajax({
type: 'POST',
url: link,
 success: function (data) { 
      $.ajax({
        url: current_url,
        data: "",
        type: "GET",
        dataType: "html",
        success: function (data) {
$(".quick-cart__wrapper").html($(".quick-cart__wrapper", data).html());
$(".lp_cart_icon").html($(".lp_cart_icon", data).html());
$('.quick-cart').addClass('animation--quick-cart-revealed');
$('.quick-cart__wrapper').addClass('active');
$('body').attr('data-fluorescent-overlay-open','true');
this_element.removeClass('loading_hk'); 
        },
        error: function (xhr, status) {},
        complete: function (xhr, status) {},
      });
 } 
 });
});



$(document).on("click", ".quantity_plus", function (e) {
  var input = $(this).parents(".label_quantity").find("input");
  var current_value = parseInt(input.val());
  var new_value = parseInt(current_value + 1);
  input.val(new_value);

var this_element =  jQuery('.quick-cart__container');
  this_element.addClass("loading_hk");
  var id = input.attr("variant_id");
  var selling_plan = input.attr("selling_plan");
  var line = input.attr("line");
  var quantity = input.val();
  var current_url = location.href;
  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      line: line,
      quantity: quantity,
      id: id,
      selling_plan: selling_plan,
    },
    dataType: "json",
    success: function (data) {
      $.ajax({
        url: current_url,
        data: "",
        type: "GET",
        dataType: "html",
        success: function (data) {
$(".quick-cart__wrapper").html($(".quick-cart__wrapper", data).html());
$(".lp_cart_icon").html($(".lp_cart_icon", data).html());
$('.quick-cart').addClass('animation--quick-cart-revealed');
$('.quick-cart__wrapper').addClass('active');
$('body').attr('data-fluorescent-overlay-open','true');
this_element.removeClass('loading_hk'); 
        },
        error: function (xhr, status) {},
        complete: function (xhr, status) {},
      });
    },
  });
});

$(document).on("click", ".quantity_minus", function (e) {
  var input = $(this).parents(".label_quantity").find("input");
  var current_value = parseInt(input.val());
  var new_value = parseInt(current_value - 1);
  input.val(new_value);
  var current = parseInt(0);

var this_element =  jQuery('.quick-cart__container');
  this_element.addClass("loading_hk");
  var id = input.attr("variant_id");
  var selling_plan = input.attr("selling_plan");
  var line = input.attr("line");
  var quantity = input.val();
  var current_url = location.href;
  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      line: line,
      quantity: quantity,
      id: id,
      selling_plan: selling_plan,
    },
    dataType: "json",
    success: function (data) {
      $.ajax({
        url: current_url,
        data: "",
        type: "GET",
        dataType: "html",
        success: function (data) {
$(".quick-cart__wrapper").html($(".quick-cart__wrapper", data).html());
$(".lp_cart_icon").html($(".lp_cart_icon", data).html());
$('.quick-cart').addClass('animation--quick-cart-revealed');
$('.quick-cart__wrapper').addClass('active');
$('body').attr('data-fluorescent-overlay-open','true');
this_element.removeClass('loading_hk'); 
        },
        error: function (xhr, status) {},
        complete: function (xhr, status) {},
      });
    },
  });
});



$(document).on("click", ".cart_item_bottom:not(.active)", function (e) {
  e.preventDefault();
  $(this).removeClass('active');
var this_element =  jQuery('.quick-cart__container');
  this_element.addClass("loading_hk");
  var id = jQuery(this).attr("variant_id");
  var selling_plan = jQuery(this).attr("selling_plan");
  var line = jQuery(this).attr("line");
  var quantity = jQuery(this).attr("quantity");
  var current_url = location.href;
  $(this).toggleClass('active');
  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      line: line,
      quantity: quantity,
      id: id,
      selling_plan: selling_plan,
    },
    dataType: "json",
    success: function (data) {
      $.ajax({
        url: current_url,
        data: "",
        type: "GET",
        dataType: "html",
        success: function (data) {
$(".quick-cart__wrapper").html($(".quick-cart__wrapper", data).html());
$(".lp_cart_icon").html($(".lp_cart_icon", data).html());
$('.quick-cart').addClass('animation--quick-cart-revealed');
$('.quick-cart__wrapper').addClass('active');
$('body').attr('data-fluorescent-overlay-open','true');
this_element.removeClass('loading_hk'); 
        },
        error: function (xhr, status) {},
        complete: function (xhr, status) {},
      });
    },
  });
});

$(document).on("click", ".cart_item_bottom.active", function (e) {
  e.preventDefault();
  $(this).removeClass('active');
var this_element =  jQuery('.quick-cart__container');
  this_element.addClass("loading_hk");
  var id = jQuery(this).attr("variant_id");
  var selling_plan = jQuery(this).attr("selling_plan");
  var line = jQuery(this).attr("line");
  var quantity = jQuery(this).attr("quantity");
  var current_url = location.href;
  $(this).toggleClass('active');
  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      line: line,
      quantity: quantity,
      id: id,
      selling_plan: null,
    },
    dataType: "json",
    success: function (data) {
      $.ajax({
        url: current_url,
        data: "",
        type: "GET",
        dataType: "html",
        success: function (data) {
$(".quick-cart__wrapper").html($(".quick-cart__wrapper", data).html());
$(".lp_cart_icon").html($(".lp_cart_icon", data).html());
$('.quick-cart').addClass('animation--quick-cart-revealed');
$('.quick-cart__wrapper').addClass('active');
$('body').attr('data-fluorescent-overlay-open','true');
this_element.removeClass('loading_hk'); 
        },
        error: function (xhr, status) {},
        complete: function (xhr, status) {},
      });
    },
  });
});





$(document).on("click", ".quick-cart__items .upsell_main", function (e) {
  e.preventDefault();
  $(this).addClass('active');
var this_element =  jQuery('.quick-cart__container');
  this_element.addClass("loading_hk");
  var id = jQuery(this).attr("variant_id");
  var line = jQuery(this).attr("line");
  var current_url = location.href;
  jQuery.ajax({
    type: "POST",
url: '/cart/add.js',
    data: {
      quantity: 1,
      id: id
    },
    dataType: "json",
    success: function (data) {
      $.ajax({
        url: current_url,
        data: "",
        type: "GET",
        dataType: "html",
        success: function (data) {
$(".quick-cart__wrapper").html($(".quick-cart__wrapper", data).html());
$(".lp_cart_icon").html($(".lp_cart_icon", data).html());
$('.quick-cart').addClass('animation--quick-cart-revealed');
$('.quick-cart__wrapper').addClass('active');
$('body').attr('data-fluorescent-overlay-open','true');
this_element.removeClass('loading_hk'); 
        },
        error: function (xhr, status) {},
        complete: function (xhr, status) {},
      });
    },
  });
});




function isScrolledIntoView2(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
docViewBottom = docViewBottom-($(window).height()/2)+($(elem).height())+100;
    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom));
}

$(window).scroll(function () {
    $('.timeline_icons .icons_with_text_item').each(function () {
        if (isScrolledIntoView2(this) === true) {
            $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
    });

});

$(document).on("click", "[data-js-cart-icon]", function (e) {
  e.preventDefault();
$('.quick-cart').addClass('animation--quick-cart-revealed');
$('.quick-cart__wrapper').addClass('active');
$('body').attr('data-fluorescent-overlay-open','true');
});



$(document).on("click", ".cart_item.custom_bundle_item span.remove_item", function (e) {
var this_element =  jQuery('.quick-cart__container');
this_element.addClass('loading_hk');
var link = $('.cart_item.custom_bundle_item_kit .remove_item').attr('href');
var current_url = location.href;
var id = $('.cart_item.custom_bundle_item .label_quantity input').attr('variant_id');
var line = $('.cart_item.custom_bundle_item .label_quantity input').attr('line');
jQuery.ajax({
type: 'POST',
url: link,
 success: function (data) { 
  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      line: line,
      quantity: 0,
      id: id
    },
    dataType: "json",
    success: function (data) {
      $.ajax({
        url: current_url,
        data: "",
        type: "GET",
        dataType: "html",
        success: function (data) {
$(".quick-cart__wrapper").html($(".quick-cart__wrapper", data).html());
$(".lp_cart_icon").html($(".lp_cart_icon", data).html());
$('.quick-cart').addClass('animation--quick-cart-revealed');
$('.quick-cart__wrapper').addClass('active');
$('body').attr('data-fluorescent-overlay-open','true');
this_element.removeClass('loading_hk'); 
        },
        error: function (xhr, status) {},
        complete: function (xhr, status) {},
      });
    },
  });
 } 
 });


});



